var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-sm btn-link",staticStyle:{"color":"#6d5a3f"},on:{"click":function () {  _vm.$router.push({
                      name: 'Post',
                      params: { postId: _vm.post.id }
                    }); }}},[_vm._v(_vm._s(_vm.post.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }